<div *ngIf="forgotLoginSuccess">
    <app-sign-in [$email]="loginFound"></app-sign-in>
</div>
<form
    *ngIf="!forgotLoginSuccess"
    class="form sign-in-form"
    [formGroup]="forgotLoginForm"
    (ngSubmit)="onSubmit(forgotLoginForm.value); submitButton.disabled=true;"
>
    <h1 class="page-title">I Forgot My Email</h1>
    <p>
        Please enter the information associated with your account.
    </p>
    <div class="field">
        <label
            for="last4Ssn"
            class="label"
        >
            Last 4 of SSN
        </label>
        <input
            class="input input--large"
            formControlName="last4Ssn"
            id="last4Ssn"
            name="last4Ssn"
            type="last4Ssn"
            placeholder
            required
            maxlength="4"
        >
        <div
            *ngIf="formErrors.last4Ssn"
            class="error-message field__error-message"
        >
            {{ formErrors.last4Ssn }}
        </div>
    </div>
    <div class="field">
        <label
            for="firstName"
            class="label"
        >
            First Name
        </label>
        <input
            class="input input--large"
            formControlName="firstName"
            id="firstName"
            name="firstName"
            type="firstName"
            placeholder
            required
        >
        <div
            *ngIf="formErrors.firstName"
            class="error-message field__error-message"
        >
            {{ formErrors.firstName }}
        </div>
    </div>
    <div class="field">
        <label
            for="lastName"
            class="label"
        >
            Last Name
        </label>
        <input
            class="input input--large"
            formControlName="lastName"
            id="lastName"
            name="lastName"
            type="lastName"
            placeholder
            required
        >
        <div
            *ngIf="formErrors.lastName"
            class="error-message field__error-message"
        >
            {{ formErrors.lastName }}
        </div>
    </div>
    <div
        *ngIf="needDob"
        class="field"
    >
        <p>Please enter your date of birth.</p>
        <label
            for="dob"
            class="label"
        >
            Birthday
        </label>
        <input
            *ngIf="appSettings.IsCompatibilityMode === true"
            class="input input--select-menu"
            id="dob"
            name="dob"
            formControlName="dob"
            [class.input--invalid]="formErrors.dob"
            type="text"
            mask="00/00/0000"
        >
        <input
            *ngIf="appSettings.IsCompatibilityMode === false"
            class="input input--select-menu"
            id="dob"
            name="dob"
            formControlName="dob"
            [class.input--invalid]="formErrors.dob"
            type="date"
        >
    </div>

    <div
        *ngIf="needPhone"
        class="field"
    >
        <p>Please enter your phone number.</p>
        <label
            for="phoneNumber"
            class="label"
        >
            Phone Number
        </label>
        <input
            class="input input--large"
            formControlName="phoneNumber"
            id="phoneNumber"
            name="phoneNumber"
            type="phoneNumber"
            placeholder
        >
        <div
            *ngIf="formErrors.phoneNumber"
            class="error-message field__error-message"
        >
            {{ formErrors.phoneNumber }}
        </div>
    </div>

    <div
        *ngIf="needZip"
        class="field"
    >
        <p>Please enter your zipcode.</p>
        <label
            for="zipCode"
            class="label"
        >
            Zip Code
        </label>
        <input
            class="input input--large"
            formControlName="zipCode"
            id="zipCode"
            name="zipCode"
            type="zipCode"
            placeholder
        >
        <div
            *ngIf="formErrors.zipCode"
            class="error-message field__error-message"
        >
            {{ formErrors.zipCode }}
        </div>
    </div>

    <div class="field">
        <re-captcha
            #captchaElem
            [siteKey]="siteKey"            
            (resolved)="handleSuccess($event)"
            [size]="size"
            [hl]="lang"
            [theme]="theme"
            [type]="type"
            formControlName="recaptcha"
        >
        </re-captcha>
    </div>
    <input
        class="button"
        type="submit"
        name="submitButton"
        value="Lookup Account"
    >
    <div
        *ngIf="formError"
        class="error-message field__error-message"
    >
        {{formError}}
    </div>
</form>
